import React from 'react';
import { McCard, McTable, McTag, McButton } from '@maersk-global/mds-react-wrapper';

interface Version {
    versionNumber: string | number;
    createdBy?: string;
    createdAt?: string;
    isCurrent?: boolean;
}

interface QueryVersionsTabProps {
    versions: Version[];
    currentVersion: string | number;
    onSetCurrentVersion?: (version: string) => void;
    isSettingCurrentVersion?: boolean;
}

export const QueryVersionsTab: React.FC<QueryVersionsTabProps> = ({ 
    versions, 
    currentVersion, 
    onSetCurrentVersion, 
    isSettingCurrentVersion,
}) => {
    return (
        <McCard>
            <div style={{ padding: '24px' }}>
                <div style={{ marginBottom: '16px' }}>
                    <h2 className="mds-headline--xx-small-bold" style={{ margin: 0 }}>Version History</h2>
                </div>
                
                <McTable
                    data={versions || []}
                    columns={[
                        { id: 'versionNumber', label: 'Version' },
                        { id: 'createdBy', label: 'Created By' },
                        { id: 'createdAt', label: 'Created At' },
                        { id: 'isCurrent', label: 'Current' },
                        { id: 'actions', label: 'Actions' }
                    ]}
                    datakey="versionNumber"
                    style={{ maxHeight: '400px' }}
                >
                    {(versions || []).map((version: any) => (
                        <React.Fragment key={version.versionNumber}>
                            <div slot={`${version.versionNumber}_createdAt`}>
                                {version.createdAt ? new Date(version.createdAt).toLocaleString() : 'Unknown'}
                            </div>
                            <div slot={`${version.versionNumber}_isCurrent`}>
                                {(String(version.versionNumber) === String(currentVersion) || version.isCurrent) && (
                                    <McTag label="Current" appearance="success" fit="small" />
                                )}
                            </div>
                            <div slot={`${version.versionNumber}_actions`} style={{ display: 'flex', gap: '8px' }}>
                                {String(version.versionNumber) !== String(currentVersion) && !version.isCurrent && onSetCurrentVersion && (
                                    <McButton 
                                        variant="outlined" 
                                        appearance="secondary" 
                                        fit="small" 
                                        onClick={() => onSetCurrentVersion(String(version.versionNumber))}
                                        disabled={isSettingCurrentVersion}
                                    >
                                        Set Current
                                    </McButton>
                                )}
                            </div>
                        </React.Fragment>
                    ))}
                </McTable>
            </div>
        </McCard>
    );
};
